import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BusinessTabs.styles';
import { BusinessTabsProps } from './BusinessTabs.types';
import { BUSINESS_TABS } from './BusinessTabs.constants';

export function BusinessTabs({ activeTab }: BusinessTabsProps) {
  const { t } = useTranslation();

  return (
    <S.Tabs aria-label={t('pages.cabinet.business')}>
      {BUSINESS_TABS.map(({ name, href, translationKey }) => (
        <S.Tab key={name} href={href} replace $isActive={name === activeTab}>
          {t(translationKey)}
        </S.Tab>
      ))}
    </S.Tabs>
  );
}
